import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=3e148846&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=3e148846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e148846",
  null
  
)

export default component.exports